import React, { useContext, useEffect, useCallback, useState } from 'react';
import { API } from 'api/API';
import { Card, Col, Row, Button, CardGroup, Alert, Spinner } from 'react-bootstrap';
import { ONECLICKPAYMENTS_URL, BUSINESS_DONATION_CAUSES } from 'config/config';
import { extractError } from 'api/ErrorUtil';
import { SecurityContext } from '../../security/SecurityContext';
import { TenantContext } from '../../tenant/TenantContext';
import { formatCurrency } from 'util/Currency';
import { evenRound } from 'util/NumberUtils';
import _ from "lodash";
import { Link } from 'react-router-dom';

const OneclickPaymentTiles = () => {
    const [formData, setFormData] = useState({ errors: {} });
    const secCtx = useContext(SecurityContext);
    const { businessConfig } = useContext(TenantContext);

    const fetchInitialData = useCallback(async () => {
        try {
            let oneClickPmtsSpecResp = await API.get(ONECLICKPAYMENTS_URL);
            //let donationCauseResp = await API.get(BUSINESS_DONATION_CAUSES);
            setFormData({
                ...formData,
                oneClickPmtSpecs: oneClickPmtsSpecResp.data,
                accounts: secCtx.accounts,
                accountTypes: businessConfig.accountTypes,
                //donationCauses: donationCauseResp.data,
            });

        } catch (error) {
            let exError = extractError(error);
            if (exError.httpStatus === 404) {
                setFormData({
                    ...formData,
                    oneClickPmtSpecs: [],
                    errors: exError
                });
            } else {
                setFormData({
                    ...formData,
                    errors: exError
                });
            }
        }
    });

    useEffect(() => {
        fetchInitialData();
    }, []);

    const payOneClickPmt = async (event, oneClickPmtSpecId) => {
        try {
            setFormData({
                ...formData,
                processing: oneClickPmtSpecId,
                infoMessage: "",
                errors: {}

            });
            let oneClickPmtSpecResp = await API.post(ONECLICKPAYMENTS_URL + "/" + oneClickPmtSpecId + "/actions/pay");
            setFormData({
                ...formData,
                infoMessage: "One Click payment was successful",
                processing: null
            })
        } catch (error) {
            let exError = extractError(error);
            setFormData({
                ...formData,
                errors: exError,
                processing: null
            });

        }
    }

    return (
        <React.Fragment>
            {(businessConfig.type === 'NON_PROFIT') && (businessConfig.appFeatures.includes('DONATION_MANAGEMENT')) &&
                <div>
                    {!_.isEmpty(formData.errors) && formData.errors.httpStatus === 404 && <div>
                        OneClick Payments allows to setup a payment so that you can simply make those payments regularly by clicking a single button without having to enter credit card details.
                        <br /><br />
                        You have not setup any OneClick Payments. To set these up click on the OneClick Payments menu in the left navigation area or click <Link to="/oneclick-payments">HERE</Link>. Each one click payment that you create as given above will show up as a tile in this area as given in example image below.
                        <br /><br />
                        <img src="images/oneclickpmt1.png" /><br /><div style={{ fontWeight: "bold", color: "red" }}>This is a test image only. This will be replaced by your OneClick Payments</div>
                    </div>}
                    {!_.isEmpty(formData.errors) && formData.errors?.httpStatus !== 404 && <Alert key="danger" variant="danger">{formData.errors?.message}</Alert>}
                    {!_.isEmpty(formData.infoMessage) && <Alert key="info1" variant="info">{formData.infoMessage}</Alert>}
                    <CardGroup style={{ display: 'flex', flexWrap: 'wrap' }}>
                        {!_.isEmpty(formData.oneClickPmtSpecs) && formData.oneClickPmtSpecs.map((oneClickPmtSpec, idx) => (
                            <React.Fragment key={idx}>

                                <Card style={{ maxWidth: '14rem', marginRight: '20px', marginBottom: '20px' }}>
                                    <Card.Header>
                                        <h3>
                                            {formatCurrency(evenRound(parseFloat(oneClickPmtSpec.paymentAmount)) / 100, businessConfig.locale, businessConfig.currency)}
                                        </h3>
                                        {oneClickPmtSpec.maskedCardNumber}
                                        <hr />
                                    </Card.Header>
                                    <Card.Body>
                                        {formData.processing === oneClickPmtSpec.id ? (
                                            <Spinner
                                                style={{ marginBottom: 27 }}
                                                animation="border"
                                                variant="success"
                                            />) : (
                                            <Button variant="info" className={'btn-fill'} onClick={evt => payOneClickPmt(evt, oneClickPmtSpec.id)}>
                                                Click me to Pay!
                                            </Button>)}
                                    </Card.Body>
                                    <Card.Footer>
                                        <b>
                                            {oneClickPmtSpec.description}
                                        </b>
                                    </Card.Footer>
                                </Card>
                            </React.Fragment>
                        ))}
                    </CardGroup>
                </div>}
        </React.Fragment>
    )
}

export default OneclickPaymentTiles